export class Reader {
  constructor(name, photo) {
    this.name = name;
    this.photo = photo;
  }
}
